import { MainResumeSliceShape } from './slice';

export const mainResumeViewDataSelector = (state: MainResumeSliceShape) => state.mainResume.viewData;
